import { IViewSettings } from "./ViewSettings"

export const SHOW_AUTOMATIC_INVOICES = true
export const SHOW_ALWAYS_NEXT_INVOICE = false

export interface IViewSettingsOutgoingInvoices {
    showAutomaticInvoices?: boolean
    showAlwaysNextInvoice?: boolean
}

export default class ViewSettingsOutgoingInvoices implements IViewSettings {
    showAutomaticInvoices: boolean = SHOW_AUTOMATIC_INVOICES
    showAlwaysNextInvoice: boolean = SHOW_ALWAYS_NEXT_INVOICE

    constructor(data: IViewSettingsOutgoingInvoices) {
        if (typeof data.showAutomaticInvoices !== "undefined") {
            this.showAutomaticInvoices = data.showAutomaticInvoices
        }
        if (typeof data.showAlwaysNextInvoice !== "undefined") {
            this.showAlwaysNextInvoice = data.showAlwaysNextInvoice
        }
    }

    get isDefault() {
        return this.showAutomaticInvoices === SHOW_AUTOMATIC_INVOICES
            && this.showAlwaysNextInvoice === SHOW_ALWAYS_NEXT_INVOICE
    }
}
